module.exports = __webpack_public_path__ + "static/media/ic_arrow_drop_down_circle_48px.5fc7b1a0.svg";